const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

class PS23Tilt extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-disabled') || reduceMotion.matches || !finePointer.matches) return;
    this.handleMove = this.handleMove.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
    this.addEventListener('pointermove', this.handleMove, { passive: true });
    this.addEventListener('pointerleave', this.handleLeave, { passive: true });
  }

  disconnectedCallback() {
    this.removeEventListener('pointermove', this.handleMove);
    this.removeEventListener('pointerleave', this.handleLeave);
  }

  handleMove(event) {
    const bounds = this.getBoundingClientRect();
    const x = (event.clientX - bounds.left) / bounds.width - 0.5;
    const y = (event.clientY - bounds.top) / bounds.height - 0.5;
    this.style.setProperty('--tilt-x', `${(-y * 8).toFixed(2)}deg`);
    this.style.setProperty('--tilt-y', `${(x * 10).toFixed(2)}deg`);
    this.style.setProperty('--glow-x', `${((x + 0.5) * 100).toFixed(1)}%`);
    this.style.setProperty('--glow-y', `${((y + 0.5) * 100).toFixed(1)}%`);
  }

  handleLeave() {
    this.style.setProperty('--tilt-x', '0deg');
    this.style.setProperty('--tilt-y', '0deg');
  }
}

if (!customElements.get('ps23-tilt')) customElements.define('ps23-tilt', PS23Tilt);

function setupReveals(root = document) {
  const elements = [...root.querySelectorAll('[data-ps23-reveal]:not([data-ps23-reveal-ready])')];
  if (!elements.length) return;

  if (reduceMotion.matches || !('IntersectionObserver' in window)) {
    elements.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.16 });

  elements.forEach((element) => {
    element.setAttribute('data-ps23-reveal-ready', '');
    observer.observe(element);
  });
}

function setupFilters(root = document) {
  root.querySelectorAll('[data-ps23-filter-root]:not([data-ps23-filter-ready])').forEach((section) => {
    section.setAttribute('data-ps23-filter-ready', '');
    const buttons = [...section.querySelectorAll('[data-ps23-filter]')];
    const products = [...section.querySelectorAll('[data-ps23-product]')];

    buttons.forEach((button) => {
      button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
      button.addEventListener('click', () => {
        const filter = button.dataset.ps23Filter;
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        products.forEach((product) => {
          const tags = (product.dataset.tags || '').split('|').map((tag) => tag.trim());
          const visible = filter === 'all' || tags.includes(filter);
          product.classList.toggle('is-filtered-out', !visible);
        });
      });
    });
  });
}

function initializePS23(root = document) {
  setupReveals(root);
  setupFilters(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializePS23());
} else {
  initializePS23();
}

document.addEventListener('shopify:section:load', (event) => initializePS23(event.target));
